import React from "react";
import * as R from "ramda";
import Icon from '@ant-design/icons';
import { Row, Col } from "antd";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";

const InfinityShape = () => (
  <svg
    width="30px"
    viewBox="0 0 187.3 93.7"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      stroke="#ededed"
      id="outline"
      fill="none"
      stroke-width="8"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
    />
    <path
      id="outline-bg"
      opacity="1"
      fill="none"
      stroke="#ededed"
      stroke-width="8"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="				M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
    />
  </svg>
);

const colors = [
  "#f7fcf0",
  "#f6fcef",
  "#f6fbef",
  "#f5fbee",
  "#f4fbed",
  "#f3fbed",
  "#f3faec",
  "#f2faeb",
  "#f1faeb",
  "#f1f9ea",
  "#f0f9e9",
  "#eff9e9",
  "#eef9e8",
  "#eef8e7",
  "#edf8e7",
  "#ecf8e6",
  "#ecf8e5",
  "#ebf7e5",
  "#eaf7e4",
  "#e9f7e3",
  "#e9f6e3",
  "#e8f6e2",
  "#e7f6e1",
  "#e7f6e1",
  "#e6f5e0",
  "#e5f5df",
  "#e5f5df",
  "#e4f4de",
  "#e3f4dd",
  "#e2f4dd",
  "#e2f4dc",
  "#e1f3db",
  "#e0f3db",
  "#e0f3da",
  "#dff3d9",
  "#def2d9",
  "#def2d8",
  "#ddf2d7",
  "#dcf2d7",
  "#dcf1d6",
  "#dbf1d5",
  "#daf1d5",
  "#daf0d4",
  "#d9f0d3",
  "#d8f0d3",
  "#d8f0d2",
  "#d7efd1",
  "#d6efd1",
  "#d6efd0",
  "#d5efcf",
  "#d4eecf",
  "#d3eece",
  "#d3eecd",
  "#d2edcd",
  "#d1edcc",
  "#d0edcb",
  "#d0edcb",
  "#cfecca",
  "#ceecca",
  "#cdecc9",
  "#cdebc8",
  "#ccebc8",
  "#cbebc7",
  "#caeac6",
  "#c9eac6",
  "#c8eac5",
  "#c7e9c5",
  "#c6e9c4",
  "#c5e8c4",
  "#c5e8c3",
  "#c4e8c2",
  "#c3e7c2",
  "#c2e7c1",
  "#c1e7c1",
  "#c0e6c0",
  "#bfe6c0",
  "#bde5bf",
  "#bce5bf",
  "#bbe5be",
  "#bae4be",
  "#b9e4be",
  "#b8e3bd",
  "#b7e3bd",
  "#b6e2bd",
  "#b5e2bc",
  "#b3e1bc",
  "#b2e1bc",
  "#b1e1bb",
  "#b0e0bb",
  "#afe0bb",
  "#aedfbb",
  "#acdfbb",
  "#abdeba",
  "#aadeba",
  "#a9ddba",
  "#a7ddba",
  "#a6dcba",
  "#a5dcba",
  "#a3dbba",
  "#a2dbba",
  "#a1daba",
  "#a0daba",
  "#9ed9bb",
  "#9dd9bb",
  "#9cd8bb",
  "#9ad8bb",
  "#99d7bb",
  "#98d7bc",
  "#96d6bc",
  "#95d6bc",
  "#93d5bd",
  "#92d5bd",
  "#91d4bd",
  "#8fd3be",
  "#8ed3be",
  "#8dd2be",
  "#8bd2bf",
  "#8ad1bf",
  "#88d1c0",
  "#87d0c0",
  "#86cfc1",
  "#84cfc1",
  "#83cec1",
  "#81cec2",
  "#80cdc2",
  "#7fccc3",
  "#7dccc3",
  "#7ccbc4",
  "#7acac4",
  "#79cac5",
  "#77c9c5",
  "#76c8c6",
  "#75c8c6",
  "#73c7c7",
  "#72c6c7",
  "#70c5c7",
  "#6fc5c8",
  "#6ec4c8",
  "#6cc3c9",
  "#6bc3c9",
  "#69c2ca",
  "#68c1ca",
  "#67c0ca",
  "#65bfcb",
  "#64bfcb",
  "#63becb",
  "#61bdcc",
  "#60bccc",
  "#5fbbcc",
  "#5dbacc",
  "#5cb9cc",
  "#5ab9cd",
  "#59b8cd",
  "#58b7cd",
  "#57b6cd",
  "#55b5cd",
  "#54b4cd",
  "#53b3cd",
  "#51b2cd",
  "#50b1cd",
  "#4fb0cd",
  "#4eafcd",
  "#4caecd",
  "#4badcc",
  "#4aaccc",
  "#49abcc",
  "#48aacc",
  "#46a9cb",
  "#45a8cb",
  "#44a6cb",
  "#43a5ca",
  "#42a4ca",
  "#41a3c9",
  "#3fa2c9",
  "#3ea1c8",
  "#3da0c8",
  "#3c9ec7",
  "#3b9dc7",
  "#3a9cc6",
  "#399bc6",
  "#379ac5",
  "#3699c5",
  "#3597c4",
  "#3496c4",
  "#3395c3",
  "#3294c2",
  "#3193c2",
  "#3092c1",
  "#2f90c0",
  "#2d8fc0",
  "#2c8ebf",
  "#2b8dbf",
  "#2a8cbe",
  "#298abd",
  "#2889bd",
  "#2788bc",
  "#2687bc",
  "#2586bb",
  "#2485ba",
  "#2383ba",
  "#2282b9",
  "#2081b9",
  "#1f80b8",
  "#1e7fb7",
  "#1d7eb7",
  "#1c7db6",
  "#1b7bb5",
  "#1a7ab5",
  "#1979b4",
  "#1978b3",
  "#1877b3",
  "#1776b2",
  "#1674b1",
  "#1573b0",
  "#1472b0",
  "#1371af",
  "#1370ae",
  "#126fad",
  "#116dac",
  "#106cac",
  "#106bab",
  "#0f6aaa",
  "#0e69a9",
  "#0e67a8",
  "#0d66a7",
  "#0d65a6",
  "#0c64a5",
  "#0c63a4",
  "#0c61a3",
  "#0b60a2",
  "#0b5fa1",
  "#0a5ea0",
  "#0a5d9e",
  "#0a5b9d",
  "#0a5a9c",
  "#09599b",
  "#09589a",
  "#095699",
  "#095597",
  "#095496",
  "#095395",
  "#085294",
  "#085092",
  "#084f91",
  "#084e90",
  "#084d8e",
  "#084b8d",
  "#084a8c",
  "#08498a",
  "#084889",
  "#084688",
  "#084586",
  "#084485",
  "#084384",
  "#084182",
  "#084081"
];

const InfinityIcon = props => <Icon component={InfinityShape} {...props} />;

const dateFormatter = dateInDays => {
  const month = Math.floor(dateInDays / 31);
  const days = dateInDays % 31;

  if (month === 0) {
    return `${days} ${days === 1 ? "day" : "days"}`;
  }
  return `${month} ${month === 1 ? "month" : "months"} ${
    days !== 0 ? days : ""
  } ${days !== 0 ? (days === 1 ? "day" : "days") : ""}`;
};

const timeFormatter = timeInSeconds => {
  const minute = Math.floor(timeInSeconds / 60);
  const sec = timeInSeconds % 60;

  if (minute === 0) {
    return `${sec} sec`;
  }
  return `${minute} min ${sec !== 0 ? sec : ""} ${sec !== 0 ? "sec" : ""}`;
};

const quantityFormatter = (quantity, label) => {
  switch (label) {
    case "Metric History":
      return dateFormatter(quantity);
    case "Minimum Request Period":
      return timeFormatter(quantity);
    default:
      return quantity;
  }
};

const PlanData = ({ data, maxData, yearly }) => {
  const description = JSON.parse(data.description);
  const maxDescription = JSON.parse(maxData.description);
  const quantity = R.omit(["Notification"], description.quantity);
  const notifications = description.quantity.Notification;
  const maxQuantity = R.omit(["Notification"], maxDescription.quantity);
  const maxNotifications = maxDescription.quantity.Notification;
  const quality = R.omit(["Protocol"], description.quality);
  const protocols = description.quality.Protocol;

  const isEnterprise = data.level === 10;

  const exaggerateFactor = 1.3;
  const lengthCoefficient = yearly ? 12 : 1;

  return (
    <div className="datas">
      <Row gutter={32}>
        <Col xl={12} lg={12} md={12} sm={24}>
          {R.keys(quantity).map(el => {
            const width = isEnterprise
              ? "100"
              : el === "Minimum Request Period"
              ? Math.floor(
                  (maxQuantity[el] / (quantity[el] * exaggerateFactor)) * 100
                )
              : Math.floor(
                  (quantity[el] / (maxQuantity[el] * exaggerateFactor)) * 100
                );
            return (
              <div className="data">
                <div className="text">
                  <span className="left">{el}</span>
                  <span className="right">
                    {isEnterprise ? (
                      <InfinityIcon />
                    ) : (
                      quantityFormatter(quantity[el], el)
                    )}
                  </span>
                </div>

                <div class="progress2 progress-moved">
                  <Tooltip
                    title={`${
                      isEnterprise ? "∞" : quantityFormatter(quantity[el], el)
                    }`}
                    size="big"
                    theme="light"
                    position="bottom"
                  >
                    <div
                      class="progress-bar2"
                      style={{
                        width: `${width}%`,
                        "background-color": `${
                          isEnterprise
                            ? colors[255]
                            : colors[Math.floor((colors.length * width) / 100)]
                        }`
                      }}
                    ></div>
                  </Tooltip>
                </div>
              </div>
            );
          })}

          <Row gutter={32} className="notif-plan">
            {R.keys(R.omit(["_active"], notifications)).map(el => {
              const width = isEnterprise
                ? "100"
                : Math.floor(
                    (notifications[el].maximum /
                      (maxNotifications[el].maximum * exaggerateFactor)) *
                      100
                  );
              return (
                <>
                  {notifications[el]._active ? (
                    <Col xl={12} lg={12} md={12} sm={24}>
                      <div className="data">
                        <div className="text">
                          <span className="left">{el}</span>
                          <span className="right">
                            {isEnterprise ? (
                              <InfinityIcon />
                            ) : (
                              notifications[el].maximum * lengthCoefficient
                            )}
                          </span>
                        </div>

                        <div class="progress2 progress-moved">
                          <Tooltip
                            title={`${
                              isEnterprise ? "∞" : notifications[el].maximum
                            }`}
                            size="big"
                            theme="light"
                            position="bottom"
                          >
                            <div
                              class="progress-bar2"
                              style={{
                                width: `${width}%`,
                                "background-color": `${
                                  isEnterprise
                                    ? colors[255]
                                    : colors[
                                        Math.floor(
                                          (colors.length * width) / 100
                                        )
                                      ]
                                }`
                              }}
                            ></div>
                          </Tooltip>
                        </div>
                      </div>
                    </Col>
                  ) : (
                    undefined
                  )}
                </>
              );
            })}
          </Row>
        </Col>

        <Col xl={12} lg={12} md={12} sm={24}>
          <div className="data">
            <ul id="ul">
              {R.keys(quality).map(el => (
                <li
                  className={`${quality[el]._active ? "active" : "de-active"}`}
                >
                  {quality[el]._active ? <p>{el}</p> : <del>{el}</del>}
                </li>
              ))}
            </ul>
          </div>

          <Row gutter={32} className="protocol-plan">
            <div className="data">
              <ul id="ul">
                {R.keys(protocols).map(el => (
                  <Col xl={12} lg={12} md={12} sm={24}>
                    <li
                      className={`${
                        protocols[el]._active ? "active" : "de-active"
                      }`}
                    >
                      {protocols[el]._active ? <p>{el}</p> : <del>{el}</del>}
                    </li>
                  </Col>
                ))}
              </ul>
            </div>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default PlanData;
